var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLetterRequest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E5EAEF",
    d: "M0 0h79v80H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.127 27.829v.213l.177.12 10.312 6.9s0 0 0 0a2.23 2.23 0 01.984 1.853v40.466a2.215 2.215 0 01-2.21 2.219H2.61A2.215 2.215 0 01.4 77.381V36.915c0-.741.373-1.437.985-1.854 0 0 0 0 0 0l10.31-6.892.178-.118V2.619c0-1.226.991-2.219 2.21-2.219h50.834c1.219 0 2.21.993 2.21 2.219v25.21zM29.943 57.477l.496-.333-.497-.332-24.5-16.39-.622-.416v34.276l.623-.417 24.5-16.388zm15.892 1.086l-.1-.068H33.265l-.101.068L9.44 74.43l-1.095.732H70.654l-1.096-.733-23.723-15.866zm3.222-1.752l-.497.333.497.333 24.5 16.388.623.417V40.006l-.623.417-24.5 16.389zM72.69 37.77l.497-.332-.497-.333-4.94-3.31-.622-.417v8.11l.622-.416 4.94-3.302zM62.707 5.238v-.4H16.293v39.609l.178.12 16.694 11.166.1.068H45.735l.101-.068L62.53 44.566l.177-.119V5.238zM11.25 41.072l.622.416V33.387l-.622.416-4.94 3.302-.498.332.498.333 4.94 3.302z",
    fill: "#ED1B2E",
    stroke: "#E5EAEF",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.483 20.084h32.034c.96 0 1.737-.779 1.737-1.743 0-.964-.776-1.743-1.737-1.743H23.483c-.96 0-1.737.779-1.737 1.743 0 .964.776 1.743 1.737 1.743zM23.483 28.472h32.034c.96 0 1.737-.78 1.737-1.743 0-.964-.776-1.744-1.737-1.744H23.483c-.96 0-1.737.78-1.737 1.744s.776 1.743 1.737 1.743zM23.483 36.859h32.034c.96 0 1.737-.78 1.737-1.744s-.776-1.743-1.737-1.743H23.483a1.744 1.744 0 000 3.487z",
    fill: "#ED1B2E"
  })));
}

export default SvgLetterRequest;